import { WZStatus } from '../types/wz';



const EDITABLE_WZ_STATUSES = Object.values(WZStatus);

const EDITABLE_STATUS_TRANSITIONS: Record<WZStatus, WZStatus[]> = {
  [WZStatus.DRAFT]: [WZStatus.DRAFT, WZStatus.RELEASED, WZStatus.CANCELLED],
  [WZStatus.CONFIRMED]: [WZStatus.CONFIRMED, WZStatus.RELEASED, WZStatus.CANCELLED],
  [WZStatus.RELEASED]: [WZStatus.RELEASED],
  [WZStatus.RECEIVED]: [WZStatus.RECEIVED],
  [WZStatus.CANCELLED]: [WZStatus.CANCELLED],
};

export function isWZEditable(status?: WZStatus) {
  return !status || EDITABLE_WZ_STATUSES.includes(status);
}

export function canShowWZEditAction(status: WZStatus) {
  return EDITABLE_WZ_STATUSES.includes(status);
}

export function getEditableWZStatusOptions(status?: WZStatus, isNewDocument = false) {
  if (isNewDocument) {
    return [WZStatus.DRAFT];
  }

  return EDITABLE_STATUS_TRANSITIONS[status || WZStatus.DRAFT];
}
